module.exports = __webpack_public_path__ + "static/img/2.dc81bfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ajbz/2.png
// module id = 8gAP
// module chunks = 0